export default __webpack_public_path__ + "static/media/nifty-momentum-card-banner.10e678ac.png";